import { axiosInstance } from "../../../axios/axiosInstance";

const API_SUBSCRIPTION_PLAN_MODULE_URL = "admin/subscription-plan";
const API_SUBSCRIPTION_PLAN_MODULE_LIST_URL = API_SUBSCRIPTION_PLAN_MODULE_URL +  "/list"
const API_UPDATE_SUBSCRIPTION_MODULE_URL = API_SUBSCRIPTION_PLAN_MODULE_URL +  "/update"

export const getSubscriptionPlans = (dataToBeSent) => {
  return axiosInstance.get(`${API_SUBSCRIPTION_PLAN_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}&filters[type]=${dataToBeSent?.type || ""}`);
};

export const updateSubscriptionPlan = ({_id, ...rest}) => {
  return axiosInstance.post(`${API_UPDATE_SUBSCRIPTION_MODULE_URL}/${_id}`, rest);
};